// extracted by mini-css-extract-plugin
module.exports = {"shelf":"Shelves_shelf__gqF1_","shelf_disabled":"Shelves_shelf_disabled__Yh6ey","scrollStyle":"Shelves_scrollStyle__lDO4C"};